/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ProfileContext } from '../models/ProfileContext';
import type { UserProfile } from '../models/UserProfile';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class UsersService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Check if an email is already registered
     * @returns any Email check result
     * @throws ApiError
     */
    public getUsersCheckEmail({
        email,
    }: {
        email: string,
    }): CancelablePromise<{
        exists: boolean;
        isClaimed: boolean | null;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/users/check-email',
            query: {
                'email': email,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }

    /**
     * Get current user profile
     * @returns any User profile
     * @throws ApiError
     */
    public getUsersProfile(): CancelablePromise<{
        user: UserProfile;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/users/profile',
            errors: {
                401: `Unauthorized`,
            },
        });
    }

    /**
     * Update user profile
     * @returns any Profile updated successfully
     * @throws ApiError
     */
    public patchUsersProfile({
        requestBody,
    }: {
        requestBody: {
            name?: string;
            timezone?: string;
            longTermGoal?: string | null;
            termsAcceptedAt?: string;
        },
    }): CancelablePromise<{
        user: UserProfile;
    }> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/users/profile',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid timezone`,
                401: `Unauthorized`,
            },
        });
    }

    /**
     * Delete current user account and all associated data
     * @returns any Account deleted successfully
     * @throws ApiError
     */
    public deleteUsersAccount(): CancelablePromise<{
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/users/account',
            errors: {
                401: `Unauthorized`,
            },
        });
    }

    /**
     * Delete current user account and all associated data
     * @returns any Account deleted successfully
     * @throws ApiError
     */
    public deleteUsersMe(): CancelablePromise<{
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/users/me',
            errors: {
                401: `Unauthorized`,
            },
        });
    }

    /**
     * Get the current user's profile context (history, notes, emotional driver)
     * @returns ProfileContext Profile context
     * @throws ApiError
     */
    public getUsersProfileContext(): CancelablePromise<ProfileContext> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/users/profile-context',
            errors: {
                401: `Unauthorized`,
            },
        });
    }

    /**
     * Merge profile context fields (arrays merged by id, scalars replaced)
     * @returns ProfileContext Updated profile context
     * @throws ApiError
     */
    public patchUsersProfileContext({
        requestBody,
    }: {
        requestBody: {
            longTermGoal?: string | null;
            history?: Array<{
                id?: string | null;
                category: string;
                description: string;
            }>;
            notes?: Array<{
                id?: string | null;
                type: 'injury' | 'restriction' | 'surgery' | 'other';
                note: string;
                location: string;
            }>;
        },
    }): CancelablePromise<ProfileContext> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/users/profile-context',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }

}
